module.exports = __webpack_public_path__ + "img/Gibson-Bold.6210ea99.svg";